import React, { useState } from "react";

function Bodyfat() {
  const [gender, setGender] = useState("male");
  const [height, setHeight] = useState("");
  const [neck, setNeck] = useState("");
  const [waist, setWaist] = useState("");
  const [hip, setHip] = useState("");
  const [bodyFat, setBodyFat] = useState("");
  const [errors, setErrors] = useState({});

  // Input limits
  const HEIGHT_MIN = 20;
  const HEIGHT_MAX = 110;
  const NECK_MIN = 5;
  const NECK_MAX = 25;
  const WAIST_MIN = 15;
  const WAIST_MAX = 120;
  const HIP_MIN = 10;
  const HIP_MAX = 100;

  const clearForm = () => {
    setHeight("");
    setNeck("");
    setWaist("");
    setHip("");
    setBodyFat("");
    setErrors({});
  };

  // const validateInputs = () => {
  //   const newErrors = {};
    
  //   // Height validation
  //   if (!height) {
  //     newErrors.height = "Height is required";
  //   } else if (isNaN(height) || parseFloat(height) <= 0) {
  //     newErrors.height = "Please enter a valid positive number for height";
  //   } else {
  //     const heightVal = parseFloat(height);
  //     if (heightVal < HEIGHT_MIN || heightVal > HEIGHT_MAX) {
  //       newErrors.height = `Height must be between ${HEIGHT_MIN} and ${HEIGHT_MAX} inches`;
  //     }
  //   }
    
  //   // Neck validation
  //   if (!neck) {
  //     newErrors.neck = "Neck circumference is required";
  //   } else if (isNaN(neck) || parseFloat(neck) <= 0) {
  //     newErrors.neck = "Please enter a valid positive number for neck circumference";
  //   } else {
  //     const neckVal = parseFloat(neck);
  //     if (neckVal < NECK_MIN || neckVal > NECK_MAX) {
  //       newErrors.neck = `Neck must be between ${NECK_MIN} and ${NECK_MAX} inches`;
  //     }
  //   }
    
  //   // Waist validation
  //   if (!waist) {
  //     newErrors.waist = "Waist circumference is required";
  //   } else if (isNaN(waist) || parseFloat(waist) <= 0) {
  //     newErrors.waist = "Please enter a valid positive number for waist circumference";
  //   } else {
  //     const waistVal = parseFloat(waist);
  //     if (waistVal < WAIST_MIN || waistVal > WAIST_MAX) {
  //       newErrors.waist = `Waist must be between ${WAIST_MIN} and ${WAIST_MAX} inches`;
  //     }
  //   }
    
  //   // Hip validation (for females only)
  //   if (gender === "female" && !hip) {
  //     newErrors.hip = "Hip circumference is required for females";
  //   } else if (gender === "female" && (isNaN(hip) || parseFloat(hip) <= 0)) {
  //     newErrors.hip = "Please enter a valid positive number for hip circumference";
  //   } else if (gender === "female") {
  //     const hipVal = parseFloat(hip);
  //     if (hipVal < HIP_MIN || hipVal > HIP_MAX) {
  //       newErrors.hip = `Hip must be between ${HIP_MIN} and ${HIP_MAX} inches`;
  //     }
  //   }
    
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };


  const validateInputs = () => {
  const newErrors = {};
  
  // Height validation
  if (!height) {
    newErrors.height = "Height is required";
  } else if (isNaN(height) || parseFloat(height) <= 0) {
    newErrors.height = "Please enter a valid positive number for height";
  } else {
    const heightVal = parseFloat(height);
    if (heightVal < HEIGHT_MIN || heightVal > HEIGHT_MAX) {
      newErrors.height = `Height must be between ${HEIGHT_MIN} and ${HEIGHT_MAX} inches`;
    }
  }
  
  // Neck validation
  if (!neck) {
    newErrors.neck = "Neck circumference is required";
  } else if (isNaN(neck) || parseFloat(neck) <= 0) {
    newErrors.neck = "Please enter a valid positive number for neck circumference";
  } else {
    const neckVal = parseFloat(neck);
    if (neckVal < NECK_MIN || neckVal > NECK_MAX) {
      newErrors.neck = `Neck must be between ${NECK_MIN} and ${NECK_MAX} inches`;
    }
  }
  
  // Waist validation
  if (!waist) {
    newErrors.waist = "Waist circumference is required";
  } else if (isNaN(waist) || parseFloat(waist) <= 0) {
    newErrors.waist = "Please enter a valid positive number for waist circumference";
  } else {
    const waistVal = parseFloat(waist);
    if (waistVal < WAIST_MIN || waistVal > WAIST_MAX) {
      newErrors.waist = `Waist must be between ${WAIST_MIN} and ${WAIST_MAX} inches`;
    }
  }
  
  // Hip validation (for females only)
  if (gender === "female" && !hip) {
    newErrors.hip = "Hip circumference is required for females";
  } else if (gender === "female" && (isNaN(hip) || parseFloat(hip) <= 0)) {
    newErrors.hip = "Please enter a valid positive number for hip circumference";
  } else if (gender === "female") {
    const hipVal = parseFloat(hip);
    if (hipVal < HIP_MIN || hipVal > HIP_MAX) {
      newErrors.hip = `Hip must be between ${HIP_MIN} and ${HIP_MAX} inches`;
    }
  }

  // 🚨 NEW CONDITIONS
  const heightNum = parseFloat(height);
  const neckNum = parseFloat(neck);
  const waistNum = parseFloat(waist);
  const hipNum = parseFloat(hip);

  if (gender === "male" && waistNum && neckNum && waistNum <= neckNum) {
    newErrors.waist = "Waist size must be larger than neck size for an accurate body fat calculation. Please recheck your measurements.";
  }

  if (gender === "female" && waistNum && hipNum && neckNum && (waistNum + hipNum) <= neckNum) {
    newErrors.hip = "The sum of waist and hip measurements must be larger than the neck size for an accurate body fat calculation. Please recheck your measurements.";
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

  const calculateBodyFat = () => {
    if (!validateInputs()) return;

    const heightNum = parseFloat(height);
    const neckNum = parseFloat(neck);
    const waistNum = parseFloat(waist);
    const hipNum = parseFloat(hip);

    let bodyFatPercent;
    if (gender === "male") {
      // Male formula: 86.010 × log10(waist - neck) - 70.041 × log10(height) + 36.76
      bodyFatPercent = 86.010 * Math.log10(waistNum - neckNum) - 70.041 * Math.log10(heightNum) + 36.76;
    } else {
      // Female formula: 163.205 × log10(waist + hip - neck) - 97.684 × log10(height) - 78.387
      bodyFatPercent = 163.205 * Math.log10(waistNum + hipNum - neckNum) - 97.684 * Math.log10(heightNum) - 78.387;
    }

    // Ensure body fat is within reasonable bounds (0-50%)
    bodyFatPercent = Math.max(0, Math.min(50, bodyFatPercent));
    setBodyFat(bodyFatPercent.toFixed(1) + "%");
  };

  // Handle input change with validation
  // const handleInputChange = (e, setter, fieldName, min, max) => {
  //   const value = e.target.value.replace(/[^0-9.]/g, '');
    
  //   if (value === '') {
  //     setter(value);
      
  //     if (errors[fieldName]) {
  //       const newErrors = {...errors};
  //       delete newErrors[fieldName];
  //       setErrors(newErrors);
  //     }
  //     return;
  //   }

  //   if (!isNaN(value) && parseFloat(value) >= 0) {
  //     setter(value);
      
  //     const numValue = parseFloat(value);
  //     if (numValue < min || numValue > max) {
  //       setErrors({
  //         ...errors,
  //         [fieldName]: `${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} must be between ${min} and ${max}`
  //       });
  //     } else {
  //       if (errors[fieldName]) {
  //         const newErrors = {...errors};
  //         delete newErrors[fieldName];
  //         setErrors(newErrors);
  //       }
  //     }
  //   }
  // };

  // Handle input change with validation
const handleInputChange = (e, setter, fieldName, min, max) => {
  let value = e.target.value.replace(/[^0-9.]/g, '');

  // ✅ Allow only one decimal point and max 1 digit after decimal
  if (value.includes(".")) {
    const parts = value.split(".");
    if (parts[1].length > 1) {
      value = parts[0] + "." + parts[1].slice(0, 1); // trim to 1 decimal
    }
  }

  // Allow empty input for backspace/delete
  if (value === '') {
    setter(value);
    
    // Clear error for this field
    if (errors[fieldName]) {
      const newErrors = {...errors};
      delete newErrors[fieldName];
      setErrors(newErrors);
    }
    return;
  }

  // Check if it's a valid positive number
  if (!isNaN(value) && parseFloat(value) >= 0) {
    setter(value);

    // Validate against limits
    const numValue = parseFloat(value);
    if (numValue < min || numValue > max) {
      setErrors({
        ...errors,
        [fieldName]: `${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} must be between ${min} and ${max}`
      });
    } else {
      // Clear error for this field if value is valid
      if (errors[fieldName]) {
        const newErrors = {...errors};
        delete newErrors[fieldName];
        setErrors(newErrors);
      }
    }
  }
};


  return (
    <div id="body_fat_tab" className="container-fluid py-4">
      <div className="row">
        {/* LEFT SIDE TEXT */}
        <div className="col-md-6 pe-md-4">
          <h3 className="mb-3" style={{ color: "#333", fontSize: "1.75rem" }}>
            Why Body Fat Measurement is Important
          </h3>
          <p style={{ fontSize: "16px", textAlign: "justify", lineHeight: "1.6", marginBottom: "1.5rem" }}>
            Body fat plays a key role in successful weight management. Fat tissue burns fewer calories than muscle tissue, so the more muscle and less fat you have, the more calories your body can burn before gaining weight. Use our body fat calculator to estimate your body fat percentage.
          </p>
          <h3 className="mt-4 mb-3" style={{ color: "#333", fontSize: "1.75rem" }}>
            Body Fat Ratio and Health
          </h3>
          <p style={{ fontSize: "16px", textAlign: "justify", lineHeight: "1.6" }}>
            A higher than healthy body fat percentage increases the risk of weight related conditions such as heart disease, high blood pressure, gallstones, type 2 diabetes, osteoarthritis, and certain cancers. In addition, since muscle is more metabolically active than fat, having more fat and less muscle lowers the number of calories your body needs to maintain weight, making weight gain easier.
          </p>
        </div>

        {/* RIGHT SIDE FORM */}
        <div className="col-md-6 ps-md-4 mt-4 mt-md-0">
          <div className="body-fat-ratio-heading btn-default">
            <h5 className="text-center" style={{ color: "#37A3EC" }}>
              Body Fat Ratio Calculator
            </h5>
          </div>
          <div style={{ backgroundColor: "#F7F7F7", padding: "25px", borderRadius: "10px" }}>
            <div className="mb-4">
              <label className="control-label mb-2"><strong>Gender*</strong></label>
              <div className="d-flex gap-4 mt-2">
                <div className="form-check">
                  <input
                    style={{padding:"0px", fontSize:"16px", marginTop:"6px"}}
                    className="form-check-input"
                    type="radio"
                    id="male"
                    name="gender"
                    value="male"
                    checked={gender === "male"}
                    onChange={(e) => {
                      setGender(e.target.value);
                      setHip(""); // Clear hip value when switching to male
                    }}
                  />
                  <label className="form-check-label ms-2" htmlFor="male">
                    Male
                  </label>
                </div>
                <div className="form-check">
                  <input
                    style={{padding:"0px", fontSize:"16px", marginTop:"6px"}}
                    className="form-check-input"
                    type="radio"
                    id="female"
                    name="gender"
                    value="female"
                    checked={gender === "female"}
                    onChange={(e) => setGender(e.target.value)}
                  />
                  <label className="form-check-label ms-2" htmlFor="female">
                    Female
                  </label>
                </div>
              </div>
            </div>

            <div className="mb-4">
              <label className="control-label mb-2"><strong>Height In Inches*</strong></label>
              <input
                className={`form-control mb-0 ${errors.height ? 'is-invalid' : ''}`}
                value={height}
                onChange={(e) => handleInputChange(e, setHeight, 'height', HEIGHT_MIN, HEIGHT_MAX)}
                placeholder={`${HEIGHT_MIN}-${HEIGHT_MAX}`}
                type="text"
              />
              {errors.height && <div className="invalid-feedback mt-0">{errors.height}</div>}
            </div>

            <div className="mb-4">
              <label className="control-label mb-2"><strong>Neck In Inches*</strong></label>
              <input
                className={`form-control mb-0 ${errors.neck ? 'is-invalid' : ''}`}
                value={neck}
                onChange={(e) => handleInputChange(e, setNeck, 'neck', NECK_MIN, NECK_MAX)}
                placeholder={`${NECK_MIN}-${NECK_MAX}`}
                type="text"
              />
              {errors.neck && <div className="invalid-feedback mt-0">{errors.neck}</div>}
            </div>

            <div className="mb-4">
              <label className="control-label mb-2"><strong>Waist In Inches</strong></label>
              <input
                className={`form-control mb-0 ${errors.waist ? 'is-invalid' : ''}`}
                value={waist}
                onChange={(e) => handleInputChange(e, setWaist, 'waist', WAIST_MIN, WAIST_MAX)}
                placeholder={`${WAIST_MIN}-${WAIST_MAX}`}
                type="text"
              />
              {errors.waist && <div className="invalid-feedback mb-0" style={{lineHeight:"15px"}}>{errors.waist}</div>}
            </div>

            {gender === "female" && (
              <div className="mb-4">
                <label className="control-label mb-2"><strong>Hip In Inches*</strong></label>
                <input
                  className={`form-control mb-0 ${errors.hip ? 'is-invalid' : ''}`}
                  value={hip}
                  onChange={(e) => handleInputChange(e, setHip, 'hip', HIP_MIN, HIP_MAX)}
                  placeholder={`${HIP_MIN}-${HIP_MAX}`}
                  type="text"
                />
                {errors.hip && <div className="invalid-feedback" style={{lineHeight:"15px"}}>{errors.hip}</div>}
              </div>
            )}

            <div className="mb-4">
              <label className="control-label mb-2"><strong>Body Fat Percentage</strong></label>
              <input
                className="form-control" 
                value={bodyFat}
                readOnly
                placeholder="Result will appear here"
              />
            </div>

            <div className="d-flex justify-content-between mt-4">
              <button
                type="button"
                onClick={calculateBodyFat}
                className="btn btn-default px-4 py-2 fw-semibold"
                // style={{ 
                //   minWidth: "120px", 
                //   fontSize: "16px",
                //   backgroundColor: "#37A3EC",
                //   borderColor: "#37A3EC",
                //   borderRadius: "5px"
                // }}
              >
                Calculate
              </button>
              <button
                type="button"
                onClick={clearForm}
                className="btn clear-values-height-predictor"
                style={{ 
                  minWidth: "90px", 
                  // fontSize: "16px",
                  // borderRadius: "5px"
                }}
              >
                Clear
              </button>
            </div>

            <div className="mt-4 p-3" style={{ backgroundColor: "#f8f9fa", borderRadius: "5px" }}>
              <h6><strong>Formula:</strong></h6>
              {gender === "male" ? (
                <p className="mb-0">Body Fat % = 86.010 × log<sub>10</sub>(Waist – Neck) – 70.041 × log<sub>10</sub>(Height) + 36.76</p>
              ) : (
                <p className="mb-0">Body Fat % = 163.205 × log<sub>10</sub>(Waist + Hip – Neck) – 97.684 × log<sub>10</sub>(Height) – 78.387</p>
              )}
              <p className="mt-2 mb-0 text-muted" style={{ fontSize: "14px" }}>
                Note: All measurements should be in inches
              </p>
            </div>
          </div>
        </div>

        {/* COMPARISON TABLE */}
        <div className="col-12 mt-5">
          <h3 className="mb-4" style={{ color: "#333", fontSize: "1.75rem" }}>
            Standard Body Fat Percentage Ranges
          </h3>
          <div className="table-responsive">
            <table className="table table-bordered text-center">
              <thead>
                <tr style={{ backgroundColor: "#37A3EC", color: "white" }}>
                  <th style={{ padding: "12px" }}>Category</th>
                  <th style={{ padding: "12px" }}>Men (%)</th>
                  <th style={{ padding: "12px" }}>Women (%)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Essential Fat</td>
                  <td>2-5</td>
                  <td>10-13</td>
                </tr>
                <tr>
                  <td>Athletes</td>
                  <td>6-13</td>
                  <td>14-20</td>
                </tr>
                <tr>
                  <td>Fitness</td>
                  <td>14-17</td>
                  <td>21-24</td>
                </tr>
                <tr>
                  <td>Average</td>
                  <td>18-24</td>
                  <td>25-31</td>
                </tr>
                <tr>
                  <td>Obese</td>
                  <td>25%+</td>
                  <td>32%+</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <style>{`
        .invalid-feedback {
          display: block;
          color: #dc3545;
          font-size: 80%;
          margin-top: 0.25rem;
        }
        .is-invalid {
          border-color: #dc3545 !important;
        }
        .btn-primary {
          background-color: #37A3EC;
          border-color: #37A3EC;
        }
        .btn-primary:hover {
          background-color: #2b8ac9;
          border-color: #2b8ac9;
        }
      `}</style>
    </div>
  );
}

export default Bodyfat;